import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import {Link, Typography} from '@nur-portal/ui-kit';

import {initAppleIdAuth} from '../../../apple-id-auth';
import {AppleButton} from '../../../website-ui/components/apple-button';
import {APPLE_BUTTON_SOURCES} from '../../../website-ui/components/apple-button/constants';
import {GoogleButton} from '../../../website-ui/components/google-button';
import {GOOGLE_BUTTON_SOURCES} from '../../../website-ui/components/google-button/constants';
import {Benefits} from '../components/benefits';
import {Navigation} from '../components/navigation';
import {NAVIGATION_ROUTES} from '../constants';

import styles from './registration.module.css';

const RegistrationPage = () => {
  const {t} = useTranslation();

  const activeRoute = NAVIGATION_ROUTES.REGISTRATION;

  useEffect(() => {
    initAppleIdAuth();
  }, []);

  return (
    <div>
      <Navigation activeRoute={activeRoute} />
      <div className={styles.container}>
        <div className={styles.benefitRoot}>
          <Typography
            variantMapping={{
              desktop: 'title-21',
              mobile: 'title-18'
            }}
            className={styles.title}
          >
            {t('registrationPage.title')}
          </Typography>
          <Benefits translationKey="registrationPage" />
        </div>
        <div className={styles.buttonWrapper}>
          <GoogleButton source={GOOGLE_BUTTON_SOURCES.REGISTRATION} />
          <div className={styles.appleButtonWrapper}>
            <AppleButton source={APPLE_BUTTON_SOURCES.REGISTRATION} />
          </div>
        </div>
        <div className={styles.descriptionBlock}>
          <Typography variant="text-12" className={styles.footerText}>
            {t('registrationPage.footerTextStart')}
            <Link href={`${location.origin}/usage-agreement.html`} isExternalLink>
              {t('registrationPage.footerTextUserAgreement')}
            </Link>
            {t('registrationPage.footerTextAnd')}
            <Link href={`${location.origin}/privacy-policy.html`} isExternalLink>
              {t('registrationPage.footerTextPolicy')}
            </Link>.
          </Typography>
          <Typography variant="text-12">
            {'This site is protected by reCAPTCHA and the Google '}
            <Link href="https://policies.google.com/privacy" isExternalLink>
              Privacy Policy
            </Link>
            {' and '}
            <Link href="https://policies.google.com/terms" isExternalLink>
              Terms of Service
            </Link>
            {' apply'}.
          </Typography>
        </div>
      </div>
    </div>
  );
};

export {RegistrationPage};
